import rangeSlider from 'range-slider-input';
import 'range-slider-input/dist/style.css';
import flashScollPos from '@/utils/flashScrollPos';

export default function scrollToTop(element, data) {
    const min = data.optionsMin;
    const max = data.optionsMax;
    const inital = [data.currentMin, data.currentMax];
    const step = Math.pow(10, Math.floor(Math.log10(max - min))) * 0.01;
    const applyUrl = data.applyUrl;
    const clearUrl = data.clearUrl;
    const displayMin = element.querySelector(".min");
    const displayMax = element.querySelector(".max");

    let current = inital;

    updateDisplay();

    const rangeSliderElement = rangeSlider(element.querySelector(".slider"), {
        min: min,
        max: max,
        value: inital,
        step: step,
        onInput: function (value) {
            current = value;
            updateDisplay();
        },
        onThumbDragEnd: apply,
        onRangeDragEnd: apply
    });

    function updateDisplay() {
        displayMin.innerText = formatNumber(current[0]);
        displayMax.innerText = formatNumber(current[1]);
    }

    function apply() {
        if (current[0] == inital[0] && current[1] == inital[1]) {
            return;
        }

        if (current[0] == min && current[1] == max) {
            flashScollPos();
            window.location = clearUrl;
        } else {
            const formated = current.join(",");
            const url = applyUrl.split("__PLACEHOLDER__").join(formated);
            flashScollPos();
            window.location = url;
        }
    }

    function formatNumber(num) {
        return num.toLocaleString("ru-RU");
    }
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary